import { ReactChild } from "react";
import styled from "@emotion/styled";

import LandingHeader from "@/components/LandingHeader";
import Footer from "@/components/Footer";
import { useIsMedium } from "@/styles/breakpoints";

const BackgroundImageContainer = styled.div`
  position: relative;
`;

// Note that the layout assumes there is only one child
export default function MainLayout({
  children,
  backgroundImage,
  ctaOutlined,
}: {
  children: ReactChild;
  backgroundImage?: ReactChild;
  ctaOutlined?: boolean;
}) {
  const isMedium = useIsMedium();
  return (
    <>
      <LandingHeader ctaOutlined={ctaOutlined} />
      {children}
      <div>
        {isMedium && backgroundImage && (
          <BackgroundImageContainer>{backgroundImage}</BackgroundImageContainer>
        )}
        <Footer />
      </div>
    </>
  );
}
